import * as _accessors from './accessors';
import * as _actions from './actions';
import _reducer from './reducer';
import _StudentHomeworkDetail, { UnitResult as _UnitResult } from './model';

export const accessors = _accessors;
export const actions = _actions;
export const reducer = _reducer;
export const StudentHomeworkDetail = _StudentHomeworkDetail;
export const UnitResult = _UnitResult;



// WEBPACK FOOTER //
// ./data/RAv2HomeworkResultDetail/index.js